const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export const fetchLCKMatches = async () => {
    const res = await fetch(`${API_URL}/api/matches`);
    if (!res.ok) throw new Error(`API: ${res.status}`);
    return res.json();
};

export const fetchMatchesByPage = async (overviewPage) => {
    const res = await fetch(`${API_URL}/api/matches?page=${encodeURIComponent(overviewPage)}`);
    if (!res.ok) throw new Error(`API: ${res.status}`);
    return res.json();
};

export const computeStandings = (equipes, matches, winScore = 2) => {
    const wins = {};
    const losses = {};
    const gameWins = {};
    const gameLosses = {};
    equipes.forEach(e => {
        wins[e.teamtag] = 0;
        losses[e.teamtag] = 0;
        gameWins[e.teamtag] = 0;
        gameLosses[e.teamtag] = 0;
    });

    matches.forEach(({ team1, team2, score1, score2 }) => {
        if (score1 === null || score2 === null) return;
        if (score1 === 0 && score2 === 0) return;
        if (score1 !== winScore && score2 !== winScore) return;
        if (score1 > score2) {
            if (wins[team1] !== undefined) wins[team1]++;
            if (losses[team2] !== undefined) losses[team2]++;
        } else {
            if (wins[team2] !== undefined) wins[team2]++;
            if (losses[team1] !== undefined) losses[team1]++;
        }
        if (gameWins[team1] !== undefined) { gameWins[team1] += score1; gameLosses[team1] += score2; }
        if (gameWins[team2] !== undefined) { gameWins[team2] += score2; gameLosses[team2] += score1; }
    });

    return equipes.map(e => ({
        ...e,
        wins: wins[e.teamtag] ?? 0,
        losses: losses[e.teamtag] ?? 0,
        gamePoints: (gameWins[e.teamtag] ?? 0) - (gameLosses[e.teamtag] ?? 0),
    }));
};
